import React, { useEffect } from "react";
import { json, showDiscriminate } from "helpers/data";
import ServerImage from "components/server-image/server-image";
import { FavIcon } from "components/favIcon";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { create_Addons_wishList, delete_Addons_wishList } from "services/wishListServices";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "react-query";
import { useAuthContext } from "store/auth";
import { Dropdown } from "react-bootstrap";
import { get_addon_price } from "../addon-detail.service";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import SorryModal from "./sorry-popup";
import { useModal } from "hooks";

interface Props {
  logo: any;
  title: string;
  label: any;
  numberOfDownloads?: number;
  isInWishlist: boolean;
  addonId: any;
  purchasedVersions: any;
  versionId?: number;
  onVersionChange: (versionId: number) => void;
}

function AddonHeader({ logo, title, label, numberOfDownloads = 0, isInWishlist, addonId, purchasedVersions }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [{ user }] = useAuthContext();
  const [favColor, setFavColor] = React.useState(isInWishlist || false);
  const [priceLevel, setPriceLevel] = React.useState();
  const [subscriptionTypeId, setSubscriptionTypeId] = React.useState(2);
  const [showSorryModal, openSorryModal, closeSorryModal] = useModal(false);
  const [showPleaseModal, openPleaseModal, closePleaseModal] = useModal(false);


  const { id } = useParams();

  useEffect(() => {
    setFavColor(isInWishlist);
  }, [isInWishlist]);

  const handleFav = () => {
    setFavColor(!favColor);
    if (favColor) {
      removeAppsWishList();
    } else {
      handleAppsWishList();
    }
  };

  const handleAppsWishList = () => {
    const data = { customerId: user.Id, addonId: addonId };
    create_Addons_wishList(data)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.added"));
      })
      .catch();
  };
  const removeAppsWishList = () => {
    delete_Addons_wishList(addonId)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.removed"));
      })
      .catch();
  };

  const { data: price } = useQuery(["addon-price", addonId, priceLevel], () =>
    get_addon_price(addonId, priceLevel).then((r) => r.response)
  );

  const [versionReleaseId, setVersionReleaseId] = React.useState("");
  const [versionSubscriptionId, setVersionSubscriptionId] = React.useState("");
  const [versionId, setVersionId] = React.useState("");

  let filterPrice = price && Object.values(price)[0];
  let monthlyPrice = filterPrice && Object.values(filterPrice)?.find((p: any) => p.discrimination === "Monthly");
  let foreverPrice = filterPrice && Object.values(filterPrice)?.find((p: any) => p.discrimination === "Forever");

  const priceResult = () : any => {
    if (subscriptionTypeId === 2) {
      return monthlyPrice;
    } else {
      return foreverPrice;
    }
  };
  const handlePriceLevelId = (id: any, subId: any, vId: any, versionReleaseId: any,versionSubscriptionId:any) => {
    setPriceLevel(id);
    setSubscriptionTypeId(subId);
    setVersionId(vId);
    setVersionReleaseId(versionReleaseId);
    setVersionSubscriptionId(versionSubscriptionId);
  };

  const handlePay = () => {
    if (purchasedVersions.length > 0 && versionId  ) {
      navigate(
        `/Payment-details/?VersionId=${versionId}&PriceLevelId=${price?.price?.priceLevelId}&Discriminate=${priceResult()?.discrimination}&addOnId=${id}&versionReleaseId=${versionReleaseId}&VersionSubscriptionId=${versionSubscriptionId}&paymentCountryId=${priceResult()?.paymentCountryId}`,
      );
    } else if (!versionId){
      openPleaseModal()
    }
     else {
      openSorryModal();
    }
  };
  return (
    <>
      <div className="header">
        <div className="info">
          <ServerImage className="logo" src={logo?.fullPath} alt="logo" />
          <h1 className="title">{json(title)}</h1>
          {label && (
            <HasLabel className="tag" color={label?.color}>
              {json(label?.name)}
            </HasLabel>
          )}

          <button className="wishList" onClick={handleFav}>
            <FavIcon color={favColor} />
          </button>
          <Dropdown className="app-dropdown addon-dropdown">
            <Dropdown.Toggle>
              {json(purchasedVersions?.find((v: any) => v.versionId === versionId)?.versionName ?? t("browse-apps:filterBox.chooseOneSubscription"))}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {purchasedVersions?.map((v: any) => (
                <Dropdown.Item
                  value={v.id}
                  key={v.addOnPriceId}
                  onClick={() => handlePriceLevelId(v.priceLevelId, v.subscription.id, v.versionId, v.versionReleaseId,v.versionSubscriptionId)}
                >
                  <span className="versionName">{`${json(v.versionName)}`}</span>{" "}
                  <span className="count">
                    {v.usedLicensesCount} / {v.licensesCount}{" "}
                  </span>{" "}
                  <span className="renewDate">
                    {t("browse-apps:myProducts.addonPage.renew")}:{moment(v.nextRenewDate).format("MM/DD/YYYY")}
                  </span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {priceResult() && priceResult()?.netPrice > 0 && (
          <div className="price">
            <p>
              {priceResult()?.discountPercentage > 0 && (
                <>
                  <span className="from">{t("browse-apps:filterBox.from")}</span>
                  <span className="old">{priceResult()?.priceBeforeDiscount}</span>
                </>
              )}
              <span className="newPrice">
                {priceResult()?.netPrice}{" "}
                <span>
                {json(`${priceResult()?.currencySymbol}`)} /  {json(`${showDiscriminate(`${priceResult()?.discrimination}`)}`)} 
                </span>
              </span>
            </p>
            <button className="btn-blue" onClick={handlePay}>
              {t("details:addonDetails.buyNow")}
            </button>
          </div>
        )}
      </div>
      <SorryModal show={showSorryModal} onHide={closeSorryModal} sorry />
      <SorryModal show={showPleaseModal} onHide={closePleaseModal}  />
    </>
  );
}
const HasLabel = styled.span`
  color: ${({ color }) => color};
  background-color: ${({ color }) => color + "20"};
`;
export default AddonHeader;
